import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { TaxonHierarchyComponent } from './components/taxon-hierarchy.component';
import { TaxonHierarchyItemComponent } from './components/taxon-hierarchy-item.component';
import { TaxonService } from './taxon.service';
import { MeasurementAnalysedCountComponent } from '../measurement/components/measurement-analysed-count.component';

@NgModule({
  imports: [CommonModule, SharedModule, MeasurementAnalysedCountComponent],
  declarations: [TaxonHierarchyComponent, TaxonHierarchyItemComponent],
  providers: [TaxonService],
  exports: [TaxonHierarchyComponent, TaxonHierarchyItemComponent],
})
export class TaxonModule {}
